import { createApi } from "@reduxjs/toolkit/query/react";
import { FilterValue } from "interfaces/FilterTypes";
import { customBaseQuery } from "store/utils";
import { CUSTOM_BROKER_UPLOAD_LIST } from "utils/apiRoutes";

export interface TransactionUploadResponse {
  totalCount: number;
  data: Daum[];
}

export interface Daum {
  id: number;
  uploadedAt: string;
  fileName: string;
  userUploaded: string;
  hasErrors: boolean;
  portfolio: number;
  broker: string;
  invalidPassword: boolean;
  fileFormat: string;
  portfolioMapping: boolean;
  companyMapping: boolean;
  portfolioMappingUrlPath: string;
  companyMappingUrlPath: string;
  reviewUrlPath: string;
  uploadFile: string;
  createdOn: string;
  updatedOn: string;
  owner: string;
  uploadedOn: string;
  csv: string;
  status: string;
  source: string;
  format: string;
  remarks: string;
  errorFile: any;
  transactionId: any;
  isArchive: boolean;
  brokerFormat: string;
  portfolioName: string;
  brokerIntegration: boolean;
  uploadedBy: number;
  branch: number;
  modelPortfolioVersion: any;
}

export interface RecondManagerResponse {
  totalCount: number;
  data: ReconManagerTransaction[];
}

export interface ReconManagerTransaction {
  id: number;
  userUploaded: string;
  portfolioCode?: string;
  portfolioName?: string;
  clientCode?: string;
  clientName?: string;
  createdOn: string;
  updatedOn: string;
  owner: string;
  uploadedOn: string;
  csv: string;
  status: string;
  remarks: string;
  fileName: string;
  isArchive: boolean;
  brokerName: string;
  format: string;
  uploadedBy: number;
  branch: number;
  portfolio?: number;
}

export interface CustomBrokerManagerResponse {
  totalCount: number;
  data: BrokerUpload[];
}

export interface BrokerUpload {
  id: number;
  uploadedAt: string;
  fileName: string;
  userUploaded: any;
  hasErrors: boolean;
  portfolio: any;
  broker: string;
  invalidPassword: boolean;
  fileFormat: string;
  portfolioMapping: boolean;
  companyMapping: boolean;
  portfolioMappingUrlPath: string;
  companyMappingUrlPath: string;
  reviewUrlPath: string;
  uploadFile: string;
  createdOn: string;
  updatedOn: string;
  owner: string;
  uploadedOn: string;
  csv: string;
  status: string;
  source: string;
  format: string;
  remarks: string;
  errorFile: any;
  transactionId: any;
  isArchive: boolean;
  brokerFormat: string;
  portfolioName: any;
  brokerIntegration: boolean;
  uploadedBy: any;
  branch: number;
  modelPortfolioVersion: any;
}

export const importApi = createApi({
  reducerPath: "importApi",
  baseQuery: customBaseQuery,
  tagTypes: ["ImportManager", "ReconManager", "CustomBrokerManager"],
  endpoints: (builder) => ({
    getTransactionUploads: builder.query<
      TransactionUploadResponse,
      FilterValue
    >({
      query: (params) => ({
        url: "/transaction_upload/",
        params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "ImportManager" as const,
                id: item.id,
              })),
              { type: "ImportManager", id: "LIST" },
            ]
          : [{ type: "ImportManager", id: "LIST" }],
    }),

    getReconTransactionUploads: builder.query<
      RecondManagerResponse,
      FilterValue
    >({
      query: (params) => ({
        url: "/recon_upload/",
        params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "ReconManager" as const,
                id: item.id,
              })),
              { type: "ReconManager", id: "LIST" },
            ]
          : [{ type: "ReconManager", id: "LIST" }],
    }),

    getCustomBrokerUploads: builder.query<
      CustomBrokerManagerResponse,
      FilterValue
    >({
      query: (params) => ({
        url: CUSTOM_BROKER_UPLOAD_LIST,
        params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "CustomBrokerManager" as const,
                id: item.id,
              })),
              { type: "CustomBrokerManager", id: "LIST" },
            ]
          : [{ type: "CustomBrokerManager", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTransactionUploadsQuery,
  useGetReconTransactionUploadsQuery,
  useGetCustomBrokerUploadsQuery,
} = importApi;
